import { Injectable } from '@angular/core';

import { PessoaDomain } from '@/core/api/sicom-api/registro/pessoa/pessoa.domain';
import { PrestadorPsmtMedicoResponse, PrestadorPsmtPrestadorClienteResponse } from '@/core/api/sicom-api/registro/prestador/prestador-psmt.model';
import { PrestadorFinanceiroNavigationService } from '@/features/registro/prestadores/dashboard-prestadores/components/prestador-financeiro-navigation.service';

export const PSMT_FINANCEIRO_RETURN_CONTEXT_ID = 'psmt-financeiro';

@Injectable({
    providedIn: 'root'
})
export class PsmtPrestadorFinanceiroNavigationService {
    constructor(private readonly financeiroNavigationService: PrestadorFinanceiroNavigationService) {}

    abrirPrestadorCliente(prestadorAtual: PessoaDomain | undefined, prestadorCliente: PrestadorPsmtPrestadorClienteResponse): void {
        if (!prestadorAtual?.id || !prestadorAtual.uf) {
            return;
        }
        this.financeiroNavigationService.abrirMedico(
            prestadorAtual,
            {
                id: prestadorCliente.idPrestador,
                uf: prestadorCliente.uf,
                crm: prestadorCliente.crm ?? undefined,
                nome: prestadorCliente.razaoSocial ?? undefined,
                tipo: 'PRESTADOR'
            },
            { id: PSMT_FINANCEIRO_RETURN_CONTEXT_ID, returnUrl: '/prestadores/psmt' }
        );
    }

    abrirMedico(prestadorAtual: PessoaDomain | undefined, medico: PrestadorPsmtMedicoResponse): void {
        if (!prestadorAtual?.id || !prestadorAtual.uf) {
            return;
        }
        this.financeiroNavigationService.abrirMedico(
            prestadorAtual,
            {
                id: medico.idMedico,
                uf: medico.uf,
                crm: medico.crm ?? undefined,
                nome: medico.nome ?? undefined,
                tipo: 'MEDICO'
            },
            { id: PSMT_FINANCEIRO_RETURN_CONTEXT_ID, returnUrl: '/prestadores/psmt' }
        );
    }
}
